<template>
    <div class="bng-withdrawal-codes-list">
        <div v-for="pin in withdrawPins" :key="pin.pin" class="withdrawal-codes-list-item">
            <div class="withdrawal-codes-list-inner">
                <p class="date">
                    {{pin.created | localDatetime("")}}
                    <description :obj="pin.branchObj" />
                </p>
                <p>
                    {{pin.value | currency(pin.currency)}}
                </p>
                <span
                    class="has-background-warning withdrawal-code"
                >{{pin.pin}}</span>
            </div>
            <a
                class="button withdrawal-codes-submit"
                @click="returnToBalance(pin)"
                :disabled="loading"
            >{{"components.common.withdrawal-codes-list.return" | translate}}</a>
        </div>

        <p
            class="help is-danger"
            v-if="error"
        >{{"components.common.withdrawal-codes-list.error" | translate}}</p>
    </div>
</template>

<script>
import Vue from 'vue';

import pinService from '../../../../../_common/services/pin.service';
import branchService from '../../../../../_common/services/branch.service';

import Description from '../description/description.vue';

export default {
    name: 'withdrawal-codes',
    components: { Description },
    data() {
        return {
            loading: false,
            withdrawPins: [],
            error: null
        };
    },
    async created() {
        await this.refresh();
    },
    computed: {
        player() {
            return Vue.state.player.get();
        },
        balance() {
            return this.player && this.player.balance;
        },
        balanceReal() {
            return this.balance && this.balance.real;
        }
    },
    watch: {
        balanceReal() {
            (async () => {
                await this.refresh();
            })();
        }
    },
    methods: {
        async refresh() {
            this.loading = true;
            let pins = await pinService.getNotAppliedWithdrawPins();
            for (let i = 0; i < pins.length; i++) {
                let p = pins[i];
                p.branchObj = await branchService.getBranch(p.branch);
                p.branchObj.currency = p.currency;
            }
            this.withdrawPins = pins;
            this.loading = false;
        },
        async returnToBalance(pin) {
            this.error = null;
            this.loading = true;
            let result = await pinService.apply(pin.pin);
            await this.refresh();
            this.loading = false;
            if (result.isSuccess) {
                // this.$router.push({ name: 'balance' })
            } else {
                this.error = result.error;
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/withdrawal-codes-list/withdrawal-codes-list.vue